import React from "react";

import logo from "../../../assets/Images/logo-noordhen.svg";

import { GridLoader } from "react-spinners";

import { Container } from "./styles";

const Loading = () => {
    return (
        <Container>
            <img src={logo} alt="Noordhen Brasil Loading" />

            <GridLoader color="var(--primary)" size={54} />
        </Container>
    );
};

export default Loading;
